import Img1 from "./1.webp";
import Img2 from "./2.webp";
import Img3 from "./3.webp";
import Img4 from "./4.webp";
import Img5 from "./5.webp";
import Img6 from "./6.webp";
import Img7 from "./7.webp";
import Img8 from "./8.webp";
import Img9 from "./9.webp";
import Img10 from "./10.webp";
import Img11 from "./11.webp";
import Img12 from "./12.webp";
import Img13 from "./13.webp";
import Img14 from "./14.webp";
import Img15 from "./15.webp";

const itemData = [
  {
    img: Img13,
  },
  {
    img: Img2,
  },
  {
    img: Img3,
  },
  {
    img: Img11,
  },
  {
    img: Img6,
  },
  {
    img: Img5,
  },
  {
    img: Img9,
  },
  {
    img: Img8,
  },
  {
    img: Img7,
  },
  {
    img: Img1,
  },
  {
    img: Img4,
  },
  {
    img: Img12,
  },
  {
    img: Img10,
  },
  {
    img: Img15,
  },
  {
    img: Img14,
  },
];

export default itemData;
